import axios from 'axios'

export default {
    get: () => axios.get('asset-persons'),
    getPublic: () => axios.get('asset-persons-public'),
    store: (data) => axios.post('asset-persons/store', data),
    update: (data) => axios.post('asset-persons/update', data),
    delete: (id) => axios.post('asset-persons/delete', id)
}